// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const SMSSendService = {
    /**
     * Send is the standard SMS send method.
     * Use this to send sms from a location to a customer/patient of
     * that location.
     */
    Send(fn, req) {
        return fn(`/sms/send/v3`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
};
